export default "__VITE_ASSET__05d3d663__"